import Page from "components/Page";
import React from "react";
import Invoices from "./Invoices";
import Subscription from "./Subscription";
import { decodeId } from "utils";
import { useSelector } from "react-redux";
import constants from "../../../../constants";
import { withTranslation } from "react-i18next";

function AccountOwnerSubscriptionAndInvoices({ history, match, t }) {
  const profile = useSelector((pre) => pre?.userProfile?.profile);
  const accountOwnerId = decodeId(match.params.accountOwnerId);
  const isSuperAdmin =
    profile?.role?.systemRole === constants.systemRoles.superAdmin;
  const goBack = () => history.goBack();

  return (
    <Page
      title={t("superAdmin.accountOwnersSubscriptionDetails")}
      onBack={goBack}
    >
      <Subscription
        accountOwnerId={accountOwnerId}
        isSuperAdmin={isSuperAdmin}
      />

      <Invoices accountOwnerId={accountOwnerId} />
    </Page>
  );
}

export default withTranslation()(AccountOwnerSubscriptionAndInvoices);
